<template>
    <div v-if="currentNode">
        <!-- <p class="system__heading">{{currentNode.name}}</p> -->
        <div class="system system-content system--read" v-show="page=='read'" >

          <div v-if="!mobile || contentMenu" class="system_menu">
            <div class="list">
              <a v-for="item in getHeadList" :href="`#${item.href}`" :class="{'smoll': item.class == 'h2'}" :key="item.href" @click="contentMenu = false">{{item.text}}</a>
            </div>
          </div>
          <button v-if="mobile && !contentMenu" class="btn-menu" @click="showMenu()">Содержание</button>
          <div class="system_content ql-editor" :class="{ 'system_content--hidden': mobile && contentMenu }" v-html="currentNode.content">

          </div>
        </div>

        <div class="system system--norma" v-show="page=='norma'">
          <v-data-table
            :headers="headersProperties"
            :items="getFiles.norma"
			      :loading="loadNorma"
            hide-default-footer
            >

            <template v-slot:[`item.propertyDGWs`]="{ item }">
              <span v-if="!item.update">
                {{
                  item.propertyDGWs.map(item => {
                    if (item.dataGetWay) return item.dataGetWay.wayName
                  }).join(', ')
                }}
              </span>
            </template>

            <template v-slot:[`item.propertyMediaLinks`]="{ item }">
              <div class="text-center" v-for="file in item.propertyMediaLinks" :key="'A'+file.mediaFileId">
                <video class="video" v-if="file.mediaFile.fileUrl.indexOf('.mp4') > -1" controls>
                  <source :src="apiImg + file.mediaFile.fileUrl" type="video/mp4">
                </video>

                <audio class="" v-if="file.mediaFile.fileUrl.indexOf('.mp3') > -1" controls style="display: initial; width:400px">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/mpeg">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/ogg">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/wav">
                </audio>

                <v-img
                  class="link mini"
                  @click="viewing(file)" v-if="link(file) && file.mediaFile.fileUrl.indexOf('.png') > -1 || file.mediaFile.fileUrl.indexOf('.jpg') > -1 || file.mediaFile.fileUrl.indexOf('.jpeg') > -1"
                  :alt="file.mediaFile.fileName"
                  :src="apiImg + file.mediaFile.fileUrl"
                  aspect-ratio="2.3"
                />
                <!-- <img width="150" height="100" :src="apiImg + file.mediaFile.fileUrl" :alt="file.mediaFile.fileName" class="link mini" @click="viewing(file)" v-if="link(file) && file.mediaFile.fileUrl.indexOf('.png') > -1 || file.mediaFile.fileUrl.indexOf('.jpg') > -1 || file.mediaFile.fileUrl.indexOf('.jpeg') > -1"> -->
              </div>
            </template>

          </v-data-table>
        </div>
        <div class="system system--potalogy" v-show="page=='potalogy'">
          <v-data-table
            :headers="headersProperties"
            :items="getFiles.potalogy"
			      :loading="loadPatalogy"
            hide-default-footer
            >

            <template v-slot:[`item.propertyDGWs`]="{ item }">
              <span v-if="!item.update">
                {{
                  item.propertyDGWs.map(item => {
                    if (item.dataGetWay) return item.dataGetWay.wayName
                  }).join(', ')
                }}
              </span>
            </template>

            <template v-slot:[`item.propertyMediaLinks`]="{ item }">
              <div class="text-center" v-for="file in item.propertyMediaLinks" :key="'A'+file.mediaFileId">
                <video v-if="file.mediaFile.fileUrl.indexOf('.mp4') > -1" width="400" height="300" controls>
                  <source :src="apiImg + file.mediaFile.fileUrl" type="video/mp4">
                </video>

                <audio v-if="file.mediaFile.fileUrl.indexOf('.mp3') > -1" controls style="display: initial; width:400px">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/mpeg">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/ogg">
                  <source :src="apiImg + file.mediaFile.fileUrl" type="audio/wav">
                </audio>

                <v-img
                  class="link"
                  @click="viewing(file)" v-if="link(file) && file.mediaFile.fileUrl.indexOf('.png') > -1 || file.mediaFile.fileUrl.indexOf('.jpg') > -1 || file.mediaFile.fileUrl.indexOf('.jpeg') > -1"
                  :alt="file.mediaFile.fileName"
                  :src="apiImg + file.mediaFile.fileUrl"
                  aspect-ratio="2.3"
                  contain
                />
                <!-- <img width="150" height="100" :src="apiImg + file.mediaFile.fileUrl" :alt="file.mediaFile.fileName" class="link mini" @click="viewing(file)" v-if="link(file) && file.mediaFile.fileUrl.indexOf('.png') > -1 || file.mediaFile.fileUrl.indexOf('.jpg') > -1 || file.mediaFile.fileUrl.indexOf('.jpeg') > -1"> -->
              </div>
            </template>

          </v-data-table>
        </div>

        <v-dialog
          v-model="popup.open"
          max-width="90%"
          height="90%"
        >
          <v-card>
            <v-card-title class="text-h5">
              <div class="add-files_header">
                <h2>{{popup.title}}</h2>
                <button class="filter-btn" @click="closeViewing()">
                  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L13.7279 13.7279" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                    <path d="M1 14L13.7279 1.27208" stroke="#CACDD3" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </button>
              </div>
            </v-card-title>

            <v-card-text class="d-flex">
              <img height="600" class="image-pop" v-if="popup.image" :src="popup.file" alt="">
              <iframe width="100%" height="600" class="image" v-else :src="popup.file" frameborder="0"></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
    </div>

</template>

<script>
import "./System.scss";
import "quill/dist/quill.core.css";
import {mapGetters, mapActions} from "vuex";
import _ from "lodash";
export default {
    name: "System",
    data(){
      return {
		  loadPatalogy: false,
		  loadNorma: false,
        popup: {
          open: false,
          image: true,
          title: '',
          file: '',
        },
        audio: [],
        headersProperties: [
          {
            text: 'Показатель',
            align: 'center',
            value: 'indicatorName'
          },
          { text: 'Значение', value: 'indicatorValue', align: 'center' },
          { text: 'Способ получения информации', value: 'propertyDGWs', align: 'center' },
          { text: 'Файл', value: 'propertyMediaLinks', align: 'center', width: 500 },
        ],        
        contentMenu: false
      }
    },
    props: {
        page: { type: String, required: true },
		    systemID: { type: String, required: true },
        mobile: Boolean
    },
	watch: {
		page(val) {
			if(val == 'norma') {
				this.loadNorma = true
				this.getDataTable(true, 'loadNorma')
			}
			if(val == 'potalogy') {
				this.loadPatalogy = true
				this.getDataTable(false, 'loadPatalogy')
			}
		}
	},
    methods: {
		...mapActions({
		  getPropertyFiles: "property/getPropertyFiles",
		}),
      closeViewing() {
        this.popup.file = ''
        this.popup.open = false
        this.popup.title = ''
      },
      link(file) {
        const type = _.last(file.mediaFile.fileName.split('.'))
        return type !== 'docx'
      },
      viewing(item) {
        const type = _.last(item.mediaFile.fileUrl.split('.'))
        if (type === 'webb'||type === 'png'||type === 'jpg'|| type === 'jpeg') {
            this.popup.image = true
        } else {
            this.popup.image = false
        }
        this.popup.open = true
        this.popup.title = item.mediaFile.fileName
        this.popup.file = `${this.apiImg}${item.mediaFile.fileUrl}`
      },
		  getDataTable(isNorma, loadName) {
			  this.getPropertyFiles({ id: this.systemID, isnormal: isNorma })
			  .then(res => {
				  if(res.status == 200) this[loadName] = false
			  })
		  },
      showMenu() {
        this.contentMenu = true;
        location.hash = '#top';        
      }
    },
    computed: {
        ...mapGetters({
            currentNode: 'tree/currentNode',
            getFiles: 'property/getFiles',
            apiImg: 'apiImg',
            getHeadList: 'tree/getHeadList'
        }),
    },
    created() {
      setTimeout(() => {
        if (this.$refs.audio) this.getAudio(this.$refs)
      }, 1000)
    }
};
</script>

